import { render, staticRenderFns } from "./PrestacaoContas.vue?vue&type=template&id=7921e29a&"
import script from "./PrestacaoContas.vue?vue&type=script&lang=js&"
export * from "./PrestacaoContas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports